// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"8":"editor","140":"email_verified","419":"wiki","542":"overview","884":"admin"}[chunkId] || chunkId) + "." + {"8":"69a5866b","140":"4b338017","327":"709c2d8c","419":"6db68c6b","466":"37d95c08","542":"999d8d75","884":"66a62f3d","889":"a193a12e"}[chunkId] + ".js";
};